import { getCommodityLabel } from "web_myplann/Portfolio/Forms/ToolsShared/getCommodityLabel";
import { getCryptoHoldingTypeLabel } from "web_myplann/Portfolio/Helpers/getCryptoHoldingTypeLabel";
import {
	type NormalizedTool,
	ToolKind,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

const getIdentificationLabel = (tool: NormalizedTool, t: TranslateFunction) => {
	const identification = tool.identification?.trim() ?? "";
	return tool.kind === ToolKind.Commodity
		? getCommodityLabel(identification, t)
		: identification;
};

export const getToolHeaderLabel = (
	tool: NormalizedTool,
	t: TranslateFunction,
) => {
	const name = tool.name?.trim() ?? "";
	const identification = getIdentificationLabel(tool, t);
	const holdingType = getCryptoHoldingTypeLabel(tool, t);

	const base =
		name && identification
			? `${name} (${identification})`
			: name || identification;

	return holdingType ? `${base} – ${holdingType}` : base;
};

export const getToolDetailName = (tool: NormalizedTool, t: TranslateFunction) =>
	tool.name?.trim() || getToolHeaderLabel(tool, t);
